import { ApiUtil } from "./ApiUtil";
import { AxiosRequestConfig } from "axios";
import { TimeoutOverrides } from "./Timeouts";

interface ApiOverrideState {
    urlOverrides: {
        [url: string]: number | ((param: AxiosRequestConfig) => number);
    };
    urlPrefixOverrides: {
        urlPrefix: string;
        timeout: number | ((param: AxiosRequestConfig) => number);
    }[];
}
const anonymousApis: string[] = ["api/core/TempPassword"];
const cookieAuthApis: string[] = ["api/core/LoginWithTempPassword"];

export const ApiOverride = () => {
    const state: ApiOverrideState = {
        urlOverrides: {},
        urlPrefixOverrides: []
    };

    for (const override of TimeoutOverrides) {
        const url = override.Url.toLowerCase();
        if (override.Match === "prefix") {
            state.urlPrefixOverrides.push({ urlPrefix: url, timeout: override.Timeout });
        } else {
            state.urlOverrides[url] = override.Timeout;
        }
    }

    return {
        getApiTimeOut: (param: AxiosRequestConfig) => {
            let timeout: number | undefined;
            const urlKey = ApiUtil.getRelativeUrl(param.baseURL ? param.baseURL : "", param.url ? param.url : "");
            const value = state.urlOverrides[urlKey] ?? state.urlPrefixOverrides.find((override) => urlKey.startsWith(override.urlPrefix))?.timeout;
            if (value) {
                timeout = typeof value === "number" ? value : value(param);
            }
            if (!timeout) {
                timeout = 15 * 1000;
            }
            return timeout;
        },
        tryReplaceUrl: (param: AxiosRequestConfig) => {
            /**
             * TO-DO: Dependent on work in RouteStore
             */
        },
        isAnonymousApi: (baseUrl: string, url: string) => {
            const urlKey = ApiUtil.getRelativeUrl(baseUrl, url);
            return anonymousApis.some((api) => api.toLowerCase() === urlKey);
        },
        isCookieAuthApi: (baseUrl: string, url: string) => {
            const urlKey = ApiUtil.getRelativeUrl(baseUrl, url);
            return cookieAuthApis.some((api) => api.toLowerCase() === urlKey);
        }
    };
};
